<div class="language-editor" tabIndex="0">
    <ul ng-if="treeCtrl.singleValueField">
        <li class="single-row" ng-repeat="localization in treeCtrl.item.Text.Localizations | filter: treeCtrl.arrayFilter | orderBy: 'Language.Locale'" ng-init="localization.Position = $index">
            <span class="single-col-lang" ng-if="treeCtrl.languages.length > 1">
                {{treeCtrl.translateLocale(localization.Language.Locale)}}
            </span>
            <span class="single-col-value"
                  ng-if="!localization.selected"
                  ng-click="treeCtrl.editLocalization(localization.Position, treeCtrl.item, $event)"
                  ng-class="{fade: !localization.Value || !treeCtrl.item.Active}">{{localization.Value || 'language.editor.value.missing' | translate}}</span>
            <textarea id="{{localization.Id}}"
                      class="single-col-value langEditorInput"
                      ng-if="localization.selected && (!treeCtrl.rows || treeCtrl.rows <= 1) && treeCtrl.editor === 'LabelField'"
                      ng-blur="treeCtrl.onBlur()"
                      ng-model="localization.Value"
                      c-focus="treeCtrl.inputFocused" tabindex="-1"></textarea>
            <input id="{{localization.Id}}"
                   class="single-col-value langEditorInput"
                   ng-if="localization.selected && (!treeCtrl.rows || treeCtrl.rows <= 1) && treeCtrl.editor !== 'LabelField'"
                   ng-blur="treeCtrl.onBlur()"
                   type="text" ng-model="localization.Value"
                   c-focus="treeCtrl.inputFocused" tabindex="-1"/>
            <textarea id="{{localization.Id}}"
                      class="single-col-value"
                      ng-if="localization.selected && (treeCtrl.rows && treeCtrl.rows > 1)"
                      ng-blur="treeCtrl.onBlur()"
                      rows="{{treeCtrl.rows}}" ng-model="localization.Value"
                      c-focus="treeCtrl.inputFocused" tabindex="-1"></textarea>
        </li>
    </ul>
    <ul ng-if="!treeCtrl.singleValueField">
        <li class="headline">
            <div class="move-column" ng-if="treeCtrl.usePosition"></div>
            <div ng-repeat="language in treeCtrl.languages | orderBy: 'Locale'" class="language-column headline-column" ng-if="treeCtrl.languages.length > 1">
                <div>{{treeCtrl.translateLocale(language.Locale)}}</div>
            </div>
        </li>
    </ul>
    <ul ng-if="!treeCtrl.singleValueField" class="table-wrapper"><li c-language-editor-node item="item" ng-repeat="item in treeCtrl.items | orderBy: 'Position'" ng-init="treeCtrl.setPosition(item, $index)" ng-style="treeCtrl.wrapperHeigt"></li></ul>
    <div ng-show="treeCtrl.propertiesVisible"
         class="property-list" ng-style="{'left': treeCtrl.left + 'px', 'top': treeCtrl.top + 'px'}"
         ng-mousedown="treeCtrl.mouseDownOnPropertyList($event)">
        <div ng-repeat="property in treeCtrl.properties"
             class="property-list-item"
             ng-class="{'selected':treeCtrl.isPropertySelected('{{property}}')}"
             ng-mouseover="treeCtrl.setSelectedProperty($index)"
             ng-mousedown="treeCtrl.selectProperty()"
             id="property-{{$index}}">
            {{property}}
        </div>
    </div>
</div>